import TradingOffersList from 'modules/trading/pages/TradingOffersList';
import { TradingOffersListProvider } from '../pages/TradingOffersList/context/TradingOffersListContext';

const TradingOffersListContainer = () => (
  <TradingOffersListProvider>
    <TradingOffersList />
  </TradingOffersListProvider>
);

export default TradingOffersListContainer;
